import { c as _c } from "react/compiler-runtime";
import { varAlpha } from 'minimal-shared/utils';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

export function ButtonBlur(t0) {
  const $ = _c(18);
  let other;
  let sx;
  let text;
  if ($[0] !== t0) {
    ({
      text,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = other;
    $[2] = sx;
    $[3] = text;
  } else {
    other = $[1];
    sx = $[2];
    text = $[3];
  }
  const {
    t
  } = useTranslate();
  let t1;
  if ($[4] !== sx) {
    t1 = Array.isArray(sx) ? sx : [sx];
    $[4] = sx;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = [...t1];
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [_temp];
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t || $[10] !== text) {
    t4 = t(text);
    $[9] = t;
    $[10] = text;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <Button sx={t3}>{t4}</Button>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== other || $[15] !== t2 || $[16] !== t5) {
    t6 = <Box sx={t2} {...other}>{t5}</Box>;
    $[14] = other;
    $[15] = t2;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
function _temp(theme) {
  return {
    px: 3,
    color: theme.palette.common.white,
    ...theme.mixins.bgBlur({
      color: varAlpha(theme.vars.palette.grey["900Channel"], 0.24)
    })
  };
}